export { default } from "./DeliveryRetailerCarouselContainer";
